/**
 * Extracts error message from error object with proper fallback chain
 * Considers HTTP status codes when available
 * @param {Error|Object} error - Error object from API call
 * @param {String} defaultMsg - Default message if no error extracted (optional)
 * @returns {String} Error message to display to user
 */
export const getErrorMessage = (error, defaultMsg = "An error occurred. Please try again.") => {
  if (!error) return defaultMsg;

  // Get HTTP status code if available
  const status = error.response?.status;

  // Status-specific fallback messages
  const statusMessages = {
    400: "The request was invalid. Please check your input.",
    401: "Your session has expired. Please log in again.",
    403: "You don't have permission to perform this action.",
    404: "The requested resource was not found.",
    409: "The data conflicts with existing information.",
    422: "The submitted data is invalid. Please check your input.",
    429: "Too many requests. Please wait a moment and try again.",
    500: "A server error occurred. Please try again later.",
    502: "Service temporarily unavailable. Please try again later.",
    503: "Service temporarily unavailable. Please try again later.",
  };

  // Check for axios response with data object
  if (error.response?.data) {
    // Try to get message from backend
    if (error.response.data.message) {
      return error.response.data.message;
    }
    // Try error field
    if (error.response.data.error) {
      return error.response.data.error;
    }
  }

  // Use status-specific message if available
  if (status && statusMessages[status]) {
    return statusMessages[status];
  }

  // Check for error message string
  if (error.message) {
    return error.message;
  }

  // Fallback to default
  return defaultMsg;
};
